import React, { Component } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";

import { setA11yContent } from "../NavigationHelper/actions";
import { isMobile, media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";

import CommonContainer from "common-components/Container";
import Button from "common-components/Buttons";
import { RadioButton, RadioButtonGroup } from "@vds/radio-buttons";
import { TitleLockup } from "@vds/type-lockups";
import { Feature,Body,Title } from "@vds/typography"
import { RadioFlex } from "common-components/FormContent";

import FetchPageContent from "../../../hoc/FetchPageContent";
import { FormerCustomerDeleteModal } from "./modals";

class FormerCustomerDeleteOptions extends Component {
  state = {
    visibleModal: false,
    deleteChoice: "delete-marketing",
    isOptOutChoice: "N"
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("delete information", this.props.pageContent.sc_pagetitle);
    }
  }

  handleModalPopup = () => {
    this.setState({ visibleModal: !this.state.visibleModal });
  };


  handleContinueClick = () => {
    const currentIntent = this.props.location.state && this.props.location.state.currentIntent ? this.props.location.state.currentIntent : null;
    const serviceType = this.props.location.state && this.props.location.state.serviceType ? this.props.location.state.serviceType : null;
    if (this.state.deleteChoice === "delete-marketing") {
      this.setState({ isOptOutChoice: "Y" })
    } else if (this.state.deleteChoice === "delete-personal") {
      this.setState({ isOptOutChoice: "N" })
    }
    if (this.state.deleteChoice === "delete-personal") {
      this.props.history.push({
        pathname: "/privacy/your-data/former-customer/verify-customer",
        state: { flow: "deletion", currentIntent: currentIntent, serviceType: serviceType, isOptOut: this.state.isOptOutChoice }
      })
      return;
    } else {
      this.handleModalPopup();
      return;
    }
  }

  handleRadioChange = (e) => {
    this.setState({ deleteChoice: e.target.value });
  }

  render() {

    const { pageContent, modalContent } = this.props;
    if (!this.props.location.state || !this.props.location.state.confirmAuth || !pageContent) {
      return <Redirect data-testid="redirect" to="/privacy/your-data/former-customer" />;
    }

    return (
      <div>
        <Container noTabletPadding={false}>
          <div style={{ maxWidth: "596px" }}>
          {/* VDS DPCMP-3786 ,DPCMP-3784 */}
    
          <TitleLockup
            viewport={isMobile ? "mobile": "desktop"}
            data={{
              title: {
                size: 'titleXLarge',
                bold: false,
                primitive: 'h1',
                children: pageContent.section_title
              },
              subtitle : {
                size: 'titleMedium',
                primitive: 'p',
                children: <Title>{convertStringToElements(pageContent.section_description)}</Title>
                }                  
            }}
          />
            
          </div>
          <fieldset style={{ margin: "32px 0px 24px 0px" }}>
            <div  style={{ margin: "10px 0px 24px" }}>
             <RadioButtonGroup
              onChange={this.handleRadioChange}
              defaultValue= {pageContent.genericList[0].list[1].jsonKey}
              error={false}
              data={
              [
                {
                  name: "deleteOptions",
                  children: <span style={{marginLeft:'10px'}}>{pageContent.genericList[0].list[0].jsonValue}</span>,
                  value: pageContent.genericList[0].list[0].jsonKey,
                  ariaLabel: pageContent.genericList[0].list[0].jsonValue,
                },
                {
                  name: "deleteOptions",
                  children: <span style={{marginLeft:'10px'}}>{pageContent.genericList[0].list[1].jsonValue}</span>,
                  value: pageContent.genericList[0].list[1].jsonKey,
                  ariaLabel: pageContent.genericList[0].list[0].jsonValue,

                }
              ]
            }
            />
            </div>

          </fieldset>

          <ButtonContainer>
            <Button background={pageContent.buttons[0].type} onClick={this.handleContinueClick} disabled={this.state.deleteChoice && this.state.deleteChoice.length > 0 ? false : true}>
              {pageContent.buttons[0].text}
            </Button>
            <Button
              role="link"
              background={pageContent.buttons[1].type}
              onClick={() => this.props.history.goBack()}
            >
              {pageContent.buttons[1].text}
            </Button>
          </ButtonContainer>

          <Div>
            {pageContent.genericList[0].text}
          </Div>
        </Container>
        {this.state.visibleModal && (
          <FormerCustomerDeleteModal
            visibleModal={this.state.visibleModal}
            closeModal={this.handleModalPopup}
            modalContent={modalContent}
            currentIntent={this.props.location.state.currentIntent}
            serviceType={this.props.location.state.serviceType}
            isOptOut={this.state.isOptOutChoice}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({
  pageContent: { delete_information_request: pageContent, delete_review_former: modalContent }
}) => ({
  pageContent,
  modalContent
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent }
  ),
  FetchPageContent
)(FormerCustomerDeleteOptions);

FormerCustomerDeleteOptions.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  fetchPageContent: PropTypes.func.isRequired,
  pageContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;

  ${media.tablet`
    max-width: 80%;
  `}

  ${media.mobile`
  margin: "0";
  padding: 48px 16px ;
  `}
`;

const Header = styled.h1`
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 24px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  max-width: 598px;
  font-weight:300;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
`}
`;

const HeaderDesc = styled.p`
  font-size: 20px;
  line-height: 24px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  max-width: 531px;

  ${media.mobile`
    font-size: 16px;
    line-height: 20px;
  `}
`;

const ButtonContainer = styled.div`
  display: flex;
  button,
  a {
    width: 172px;
  }
  ${media.mobile`
    flex-direction: column;    
  `}
`;

const Div = styled.div`
  max-width : 598px;
  font-size: 16px;
  line-height: 20px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  padding-top: 48px;
`;

